module.exports = __webpack_public_path__ + "img/1.165bed3f.png";